import { PencilIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import usePageIndex from "../../hooks/usePageIndex";
import { useSearch } from "../../hooks/useSearch";
import {
  deleteOperatorsById,
  getAllOperators
} from "../../services/Operators.service";
import AuditAuthor from "../audit-author/AuditAuthor";
import DeleteModal from "../ui/DeleteModal";
import IconBtn from "../ui/IconBtn";
import Table, { Row } from "../ui/table";
import Pagination from "../ui/table/Pagination";
import Can from "../users/permissions/Can";

const columns: (string | number)[] = [
  "ID",
  "Emri i operatorit",
  "Selia kryesore",
  "Detajet",
  // "Numri kontaktues",
  "Veprimet"
];

const OperatorsTable = () => {
  const { response, loading, handlePageChange, page, setResponse } = useSearch(
    getAllOperators,
    {
      withQuerySearch: true
    }
  );
  const { pageIndex, state }: any = usePageIndex();

  return (
    <div className="flex flex-col" style={{ height: "calc(100vh - 11rem)" }}>
      <Table titles={columns} style="hover" loading={loading}>
        {response?.data.result?.length ? (
          response?.data.result?.map((row) => {
            const highlighted = +state?.params?.id === row.id;
            return (
            <Row
              key={row.id}
              id={row.id}
              name={row.operatorName}
              className={`${highlighted && "highlighted"}`}
              headquartes={
                row.headQuarters === "Unknown" ? "Pa adresë" : row.headQuarters
              }
              auditAuthor={
                <AuditAuthor
                  createdByName={row.auditAuthor.createdByName}
                  createdByLastName={row.auditAuthor.createdByLastName}
                  updatedByName={row.auditAuthor.updatedByName}
                  updatedByLastName={row.auditAuthor.updatedByLastName}
                  insertDate={row.auditAuthor.insertDate}
                  updateDate={row.auditAuthor.updateDate}
                />}
              // phoneNumber={row.phoneNumber}
              actions={
                <span className="flex">
                  <Can permissions="operators.operator.update">
                    <Link
                      to={`/operators/edit/${row.id}`}
                      state={{ crumbs: ["Operatorët", "Edito Operatorin"],
                      page: pageIndex }}
                    >
                      <IconBtn className="w-6 h-6">
                        <PencilIcon className="w-4 h-4 text-neutral" />
                      </IconBtn>
                    </Link>
                  </Can>
                  <Can permissions="operators.operator.delete">
                    <DeleteModal
                      params={row.id}
                      title="Konfirmo fshirjen e operatorit."
                      handleDelete={deleteOperatorsById}
                      successMessage="Operatori është fshirë me sukses."
                      errorMessage="Operatori nuk është fshirë me sukses."
                      loadingMessage="Operatori është duke u fshirë..."
                      onSuccess={() => {
                        setResponse((prev) =>
                          prev
                            ? {
                                ...prev,
                                data: {
                                  ...prev.data,
                                  result: prev.data.result.filter(
                                    (el) => el.id !== row.id
                                  )
                                }
                              }
                            : null
                        );
                      }}
                    />
                  </Can>
                </span>
              }
            />
          );
})
        ) : (
          <></>
        )}
      </Table>
      <Pagination
        onPageChange={handlePageChange}
        totalCount={response?.data?.totalCount || 0}
        length={response?.data?.result.length}
        page={page}
        pageSize={10}
      />
    </div>
  );
};

export default OperatorsTable;
